import {createFormContext} from "@mantine/form";
import {SiteAssignmentStrategy, SiteEntity, TransportCategory} from "@ots-frontend/ots-data";

export interface SiteAssignmentSiteAssocFormValues {
  site: SiteEntity | string;
  normalRank: number;
  serviceRank: number;
}

export interface SiteSiteAssignmentFormValues {
  strategy: SiteAssignmentStrategy;
  assocs: SiteAssignmentSiteAssocFormValues[];
  entityType?: string
  entityIds?: string[]
  category?: TransportCategory
}

export interface SiteSiteAssignmentFormFieldValues {
  strategy: string;
  normalSites: { id: string }[];
  serviceSites: { id: string }[];
  entityType?: string
  entityIds?: string[]
  category?: string
}

export const [
  SiteSiteAssignmentFormProvider,
  useSiteSiteAssignmentFormContext,
  useSiteSiteAssignmentForm
] = createFormContext<SiteSiteAssignmentFormFieldValues>();
